import React from 'react'
import { TaskCardDependency } from '../../types/task-board' // Załóżmy, że ten typ istnieje lub go tworzymy

interface TaskCardDependenciesProps {
  dependencies: TaskCardDependency[]
  onShowAddDependencyModal: () => void
  onRemoveDependency: (dependencyId: string) => Promise<void>
  getDependencyTypeLabel: (type: string) => string
}

export const TaskCardDependencies: React.FC<TaskCardDependenciesProps> = ({
  dependencies,
  onShowAddDependencyModal,
  onRemoveDependency,
  getDependencyTypeLabel
}) => {
  return (
    <div style={{ border: '1px solid #e9ecef', borderRadius: '5px', marginBottom: '20px', overflow: 'hidden' }}>
      <div style={{ backgroundColor: '#f8f9fa', padding: window.innerWidth < 768 ? '8px 10px' : '10px 15px', borderBottom: '1px solid #e9ecef', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h4 style={{ fontSize: window.innerWidth < 768 ? '15px' : '16px', fontWeight: 600, margin: 0 }}>
          Powiązania
        </h4>
        <button
          onClick={onShowAddDependencyModal}
          style={{ backgroundColor: '#007bff', color: 'white', border: 'none', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' }}
        >
          Dodaj powiązanie
        </button>
      </div>
      <div style={{ padding: window.innerWidth < 768 ? '10px' : '15px' }}>
        <div className='dependency-list' style={{ marginTop: '10px' }}>
          {dependencies.length === 0 && <p style={{ fontSize: '13px', fontStyle: 'italic', color: '#6c757d', margin: '5px 0' }}>Brak powiązań</p>}
          {dependencies.map(dep => (
            <div key={dep.id} className='dependency-item' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px', borderBottom: '1px solid #f0f0f0', marginBottom: '5px' }}>
              <span className='dependency-type' style={{ fontWeight: 'bold', marginRight: '8px', display: 'inline-block' }}>
                {getDependencyTypeLabel(dep.dependencyType)}:
              </span>
              <span>
                {dep.customTaskName}
                {dep.customSubtaskName ? ` / ${dep.customSubtaskName}` : ''}
                ({dep.stageName})
              </span>
              <button
                className='btn-remove-dependency'
                onClick={async () => await onRemoveDependency(dep.id)}
                style={{ backgroundColor: '#dc3545', color: 'white', border: 'none', padding: '2px 6px', borderRadius: '3px', fontSize: '12px', cursor: 'pointer' }}
              >
                <i className='fa fa-times' />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
